export const tooltipStyle = {
  background: '#1a1a1a',
  border: '1px solid rgba(157, 157, 157, 0.3)',
  borderRadius: 8,
  fontSize: 12,
  color: '#FFFFFF',
};
export const labelStyle = { color: '#FFFFFF' };

export const fmt = n => {
  const num = Number(n) || 0;
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(num >= 10_000_000 ? 0 : 1)}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(num >= 10_000 ? 0 : 1)}K`;
  return Math.round(num).toString();
};
